import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    TablePagination,
    Chip,
    TableFooter,
    CircularProgress
} from "@mui/material";
import axiosInstance from "../../utilities/Axios";
import AlertDialog from "../AlertDialog/AlertDialog";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";
import { DeleteOutline, EditOutlined, OpenInNew, SendOutlined } from "@mui/icons-material";
import { LoadingStateContext } from "../../Hooks/LoadingContext/LoadingContext";
import { ProcessCardPassportEnumDisplayLabel } from "../../Types/Enum";
import { parseISO, format } from "date-fns";

const PassportTable = (props: { filter: any }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [countryProcess, setCountryProcess] = useState(null);
    const [countryProcessList, setCountryProcessList] = useState<any[]>([]);
    const [page, setPage] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [editDialogVisibility, setEditDialogVisibility] = useState(false);
    const [alertDialogVisibility, setAlertDialogVisibility] = useState(false);
    const [dialogAction, setDialogAction] = useState(EDialogAction.view);
    let [filter, setFilter] = useState<any>({});
    const { changeLoading, isLoading } = React.useContext(LoadingStateContext);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        getCountryProcessList();
    }, [page, limit, props.filter]);

    const getCountryProcessList = async () => {
        changeLoading(true);
        try {
            const response = await axiosInstance.get(
                `/v1/report/passport?type=${theme.theme}&page=${page}&items_per_page=${limit}`,
                {
                    params: props.filter,
                }
            );

            const data = response.data;
            setCountryProcessList(data.result.data);

            setTotalItems(data.result.total);
        } catch (err) {
            console.log(err);
        } finally {
            changeLoading(false);
        }
    };


    const goToNextPage = () => {
        setPage(page + 1);
    };

    const goToPreviousPage = () => {
        setPage(page - 1);
    };

    function editDialogClose(action: EDialogAction) {
        setEditDialogVisibility(false);
        if (action == EDialogAction.edit) {
        } else if (action == EDialogAction.view) {
        } else if (action == EDialogAction.delete) {
        }
        getCountryProcessList();
    }
    function alertDialogClose(action: EDialogAction) {
        setAlertDialogVisibility(false);
        getCountryProcessList();
    }
    function changeFilters(key: string, value: any) {
        setFilter((oldState: any) => {
            return { ...oldState, [key]: value };
        });
    }

    const naviagteToTemplates = (countryProcessId: any) => {
        navigate({
            pathname: "/admin/process-view",
            search: `?processId=${countryProcessId}`,
        });
    };

    return (
        <>
            <AlertDialog
                openAlert={alertDialogVisibility}
                onCloseAlert={alertDialogClose}
                data={countryProcess}
                action="countryProcess"
            />
            <Paper>
                <TableContainer component={Paper}>
                    <Table aria-label="country process table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Id</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Country Name</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Passport - NIC</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!isLoading && countryProcessList.map((data: any) => (
                                <TableRow key={data.id}>
                                    <TableCell>{data.id}</TableCell>
                                    <TableCell>{format(parseISO(data.date), "yyyy-MM-dd")}</TableCell>
                                    <TableCell>
                                        {data.country_process.country_name} - {data.country_process.country_code}
                                    </TableCell>
                                    <TableCell>{data.resume.first_name} {data.resume.last_name}</TableCell>
                                    <TableCell>{data.resume.passport_no} - {data.resume.nic}</TableCell>
                                    <TableCell>
                                    <div style={{ display: 'grid', width: '55%' }}>
                                        <Chip 
                                            label={ProcessCardPassportEnumDisplayLabel[data.passport_status]}
                                            color={data.passport_status === 'collect' || data.passport_status === 'return' ? 'success' : 'warning'}
                                        />
                                        </div>
                                    </TableCell>

                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            onClick={() => {
                                                naviagteToTemplates(data.id);
                                            }}
                                        >
                                            <OpenInNew />
                                        </Button>{" "}
                                    </TableCell>
                                </TableRow>
                            ))}
                            {isLoading && (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        <CircularProgress />
                                    </TableCell>
                                </TableRow>
                            )}
                            {!isLoading && countryProcessList.length == 0 && (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        No Data Found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50, 100,]}
                            count={totalItems}
                            rowsPerPage={limit}
                            page={page}
                            onPageChange={(event, newPage) => {
                                setPage(newPage);
                            }}
                            onRowsPerPageChange={(event) => {
                                setLimit(parseInt(event.target.value));
                            }}
                        />
                    </Table>
                </TableContainer>
            </Paper>
            <div className="h-12"></div>
        </>
    );
};

export default PassportTable;
